import {acquireConstants} from "../_constants";
import {acquireService} from "../_services";
import {SnackBar} from "../components/common";
import {Auth} from "../components/Authorization";
import {alertMessages} from "../_constants";
import _ from "lodash";

function getCompanyAcquireCampaigns(params) {
    const request = () => ({
        type: acquireConstants.GET_COMPANY_ACQUIRE_CAMPAIGNS_REQUEST
    });
    const success = (response) => ({
        type: acquireConstants.GET_COMPANY_ACQUIRE_CAMPAIGNS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: acquireConstants.GET_COMPANY_ACQUIRE_CAMPAIGNS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        acquireService.getCompanyAcquireCampaigns(params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401){
                Auth.processLogout();
                return;
            }
            dispatch(failure(error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

function getCompanyAcquireMetrics(params) {
    const request = () => ({
        type: acquireConstants.GET_COMPANY_ACQUIRE_METRICS_REQUEST
    });
    const success = (response) => ({
        type: acquireConstants.GET_COMPANY_ACQUIRE_METRICS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: acquireConstants.GET_COMPANY_ACQUIRE_METRICS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        acquireService.getCompanyAcquireMetrics(params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401){
                Auth.processLogout();
                return;
            }
            dispatch(failure(error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

function getOrganizationAcquireCampaigns(organizationId, params) {
    const request = () => ({
        type: acquireConstants.GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_REQUEST
    });
    const success = (response) => ({
        type: acquireConstants.GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: acquireConstants.GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        acquireService.getOrganizationAcquireCampaigns(organizationId, params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
                if(_.get(error, 'response.status') === 401){
                    Auth.processLogout();
                    return;
                }
                dispatch(failure(error));
                SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

function getOrganizationAcquireMetrics(organizationId, params) {
    const request = () => ({
        type: acquireConstants.GET_ORGANIZATION_ACQUIRE_METRICS_REQUEST
    });
    const success = (response) => ({
        type: acquireConstants.GET_ORGANIZATION_ACQUIRE_METRICS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: acquireConstants.GET_ORGANIZATION_ACQUIRE_METRICS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        acquireService.getOrganizationAcquireMetrics(organizationId, params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
                if(_.get(error, 'response.status') === 401){
                    Auth.processLogout();
                    return;
                }
                dispatch(failure(error));
                SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

export const acquireActions = {
    getCompanyAcquireCampaigns,
    getCompanyAcquireMetrics,
    getOrganizationAcquireCampaigns,
    getOrganizationAcquireMetrics
}